/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useState } from 'react'
import { Table, Divider, Select, Modal, Tooltip, DatePicker } from 'antd'
import styles from './index.less'
import moment from 'moment'
import { RESERVE_STATUS_ENUM } from '@/utils/consts'

const { Option } = Select
const ReserveList = ({ data, reserveStatus, onEdit, onEditStatus, onAddReserveFollow }) => {

  const [dataSource, setDataSource] = useState([])
  const [dataSourceClone, setDataSourceClone] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [reserveStatusVisible, setReserveStatusVisible] = useState(false)
  const [selectRocord, setSelectRecord] = useState({})
  const [arrivedAt, setArrivedAt] = useState(null)
  useEffect(() => {
    let newData = data.map(item => { return { ...item, editable: false } })
    setDataSource([...newData])
    setDataSourceClone([...data])
  }, [data])

  const columns = [
    {
      dataIndex: 'reservationAt',
      title: '预约日期',
      width: 120,
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD') : null
      }
    },
    {
      dataIndex: 'timeScope',
      title: '时间段',
      width: 120,
      render(text, record) {
        // console.log('record.startAt', record.startAt)
        // console.log('record.endAt', record.endAt)
        return record.startAt && record.endAt ? `${moment(record.startAt).format('HH:mm')} - ${moment(record.endAt).format('HH:mm')}` : null
      }
    },
    {
      dataIndex: 'clinicShortName',
      title: '预约门店',
      width: 140,
    },
    {
      dataIndex: 'comment',
      title: '备注',
      render(text, record) {
        if (text && text.length > 6) {
          return <Tooltip title={text}>{text.substr(0, 6)}...</Tooltip>
        }
        return text
      }
    },
    {
      dataIndex: 'status',
      title: '预约状态',
      width: 100,
      render(text, record, index) {
        // if(record.editable) {
        //   return <Select style={{width: 100}} value={text} onChange={(e) => {
        //     let newData = dataSource
        //     newData[index].status = e
        //     setDataSource([...newData])
        //     console.log(dataSourceClone)
        //   }}>
        //       {RESERVE_STATUS_ENUM.map(_ => <Option value={_.value} key={_.value}>{_.label}</Option>)}
        //   </Select>
        // }else {
        if (text && reserveStatus && reserveStatus.some(_ => _.value === text))
          // return reserveStatus.filter(_ => _.value === text)[0].key
          return <span className={text}>{reserveStatus.filter(_ => _.value === text)[0].key}</span>
        return text
        // }
      }
    },
    {
      dataIndex: 'operation',
      title: '操作',
      width: 100,
      align: 'center',
      render(text, record, index) {
        return <Fragment>
          {/* {record.editable && <a href="#" onClick={() => {onSaveStatus(index)}}>确定</a>} */}
          {!record.editable && <a href="javascript:void(0);" disabled={record.status === 'executed' || record.status === 'cancel' || (record.status === 'arrival' && !record.backTracking)} onClick={() => onEdit(record)}>编辑</a>}
          <Divider type="vertical" />
          {!record.editable && <a href="javascript:void(0);" disabled={record.status === 'executed' || record.status === 'cancel' || record.status === 'arrival'} onClick={() => { onChangeStatus(record) }}>状态</a>}
          {/* {record.editable && <a href="#" onClick={() => {onCancelStatus(index)}}>取消</a>} */}
        </Fragment>
      }
    }
  ]

  const onSaveStatus = (index) => {
    let newData = dataSource
    newData[index].editable = false
    setDisabled(false)
    setDataSource([...newData])
    setDataSourceClone([...newData])
    let payload = {
      id: dataSource[index].id,
      status: dataSource[index].status
    }
    let payloadFollow = {
      followUpId: dataSource[index].id,
      followUpType: 'Reservation',
    }

    if (dataSource[index].status === 'cancel') {
      Modal.confirm({
        title: '确认要将该条预约状态变更为：取消？',
        content: '',
        cancelText: '取消',
        okText: '确定',
        onOk() {
          onEditStatus(payload);
          onAddReserveFollow(payloadFollow)
        },
        onCancel() {
        },
      })
    } else {
      onEditStatus(payload)
    }
    //
  }

  const onCancelStatus = (index) => {
    let newData = dataSource
    newData[index].editable = false
    setDisabled(false)
    newData[index].status = dataSourceClone[index].status
    setDataSource([...newData])
  }

  const onChangeStatus = (record) => {
    // let newData = dataSource
    // newData[index].editable = true
    // setDataSource([...newData])
    // setDisabled(true)
    setSelectRecord({ ...record })
    setReserveStatusVisible(true)
  }

  const reserveStatusProps = {
    width: 300,
    visible: reserveStatusVisible,
    title: '更改预约状态',
    size: 'small',
    item: selectRocord,
    closable: false,
    style: { textAlign: 'center' },
    onOk() {
      let payload = {
        id: selectRocord.id,
        status: selectRocord.status
      }
      let payloadFollow = {
        followUpId: selectRocord.id,
        followUpType: 'Reservation',
      }
      if (selectRocord.status === reserveStatus.filter(_ => _.key === '到店')[0].value) {
        if (!arrivedAt) return
        payload.arrivedAt = arrivedAt
      }
      onEditStatus(payload, selectRocord.customerId);
      setReserveStatusVisible(false)
      if (selectRocord.status === reserveStatus.filter(_ => _.key === '取消')[0].value) {
        onAddReserveFollow(payloadFollow)
      }
      setSelectRecord({})
    },
    onCancel() {
      setSelectRecord({})
      setReserveStatusVisible(false)
    }
  }


  return (
    <div className={styles.reserve}>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        expandedRowRender={expandedRowRender}
        expandIcon={({ expanded, onExpand, record }) => record.reservationItemResps ? <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse'} onClick={onExpand} /></span> : null}
        size="small"
        rowKey="id"
      />
      {reserveStatusVisible && <Modal {...reserveStatusProps}>
        <Select style={{ width: 200 }} defaultValue={selectRocord.status} onChange={e =>
          setSelectRecord({ ...selectRocord, status: e })
        }>
          {reserveStatus && reserveStatus.map(_ => {
            if (_.key === '已执行') {
              return
            }else if(_.key === '取消'){
              if(selectRocord.cancelAble) {
                return <Option value={_.value} key={_.value}>{_.key}</Option>
              }else {
                return
              }
            } else if(_.key === '待确认'){
              if(selectRocord.cancelAble) {
                return <Option value={_.value} key={_.value}>{_.key}</Option>
              }else {
                return
              }
            } else {
              return <Option value={_.value} key={_.value}>{_.key}</Option>
            }
          })}
        </Select>
        {reserveStatus.filter(_ => _.value === selectRocord.status) &&
          (reserveStatus.filter(_ => _.value === selectRocord.status)[0].key === '到店' || reserveStatus.filter(_ => _.value === selectRocord.status)[0].key === '已执行') &&
          <DatePicker
            style={{ width: 200, marginTop: 20 }}
            placeholder='请选择到店时间'
            onChange={e => setArrivedAt(e)}
          />}
      </Modal>}
    </div>
  )
}

export default ReserveList

function expandedRowRender(record) {
  const columns = [
    {
      title: '序号',
      key: '$id.js.less',
      render: (_, record, index) => index + 1,
      width: 70,
      align: 'center',
    },
    {
      title: '商品类别',
      key: 'productCategoryName',
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    },
    {
      title: '商品名称',
      dataIndex: 'productName',
    },
    {
      title: '执行人',
      dataIndex: 'employeeName',
      width: 120,
    },
    {
      title: '预约时间',
      dataIndex: 'startAt',
      width: 120,
      render(text, record) {
        return text && <span>{text ? moment(text).format('HH:mm') : ''}-{record.endAt ? moment(record.endAt).format('HH:mm') : ''}</span>
      }
    },
  ]

  if (record.reservationItemResps) {
    return (
      <Fragment>
        <h4 className='order-items-label'>预约明细</h4>
        <Table columns={columns} pagination={false} bordered={false} dataSource={record.reservationItemResps || []} size='small' />
      </Fragment>)
  } else {
    return false
  }
};
